import { registryLabel } from '@/types/stats/registryLabel.ts';

/** Metryki kart finansowych, nazwy jak w wyliczeniach backendu. */
export enum FinanceMetricKey {
  PAYMENT_COUNT = 'PAYMENT_COUNT',
  BUDGET_PER_PARTICIPANT = 'BUDGET_PER_PARTICIPANT',
  REVENUE_PER_PARTICIPANT = 'REVENUE_PER_PARTICIPANT',
  PARTICIPANT_COUNT = 'PARTICIPANT_COUNT',
  AVG_PER_PARTICIPANT = 'AVG_PER_PARTICIPANT',
  AVG_PER_BOOKING = 'AVG_PER_BOOKING',
  HIGHEST = 'HIGHEST',
  LOWEST = 'LOWEST',
  BOOKING_COUNT = 'BOOKING_COUNT',
  OVERPAYMENT = 'OVERPAYMENT',
}

export const FINANCE_METRIC_LABELS: Record<FinanceMetricKey, string> = {
  [FinanceMetricKey.PAYMENT_COUNT]: 'Wpłaty',
  [FinanceMetricKey.BUDGET_PER_PARTICIPANT]: 'Budżet na uczestnika',
  [FinanceMetricKey.REVENUE_PER_PARTICIPANT]: 'Przychód na uczestnika',
  [FinanceMetricKey.PARTICIPANT_COUNT]: 'Uczestnicy',
  [FinanceMetricKey.AVG_PER_PARTICIPANT]: 'Średnia cena za uczestnika',
  [FinanceMetricKey.AVG_PER_BOOKING]: 'Średnia wartość rezerwacji',
  [FinanceMetricKey.HIGHEST]: 'Największa rezerwacja',
  [FinanceMetricKey.LOWEST]: 'Najmniejsza rezerwacja',
  [FinanceMetricKey.BOOKING_COUNT]: 'Rezerwacje',
  [FinanceMetricKey.OVERPAYMENT]: 'Nadpłata',
};

export const financeMetricLabel = (key: string): string =>
  registryLabel(FINANCE_METRIC_LABELS, key, 'metryka finansowa');
